(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    document.addEventListener('DOMContentLoaded',()=>{document.querySelectorAll('[data-cookie-preferences]').forEach(button=>button.addEventListener('click',()=>{if(window.privacyBanner&&typeof window.privacyBanner.showPreferences==='function'){window.privacyBanner.showPreferences()}else{window.location.assign('/pages/cookie-policy')}}))});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["intake-form"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded',()=>{
  const section=document.querySelector('[data-intake-section]');
  if(!section)return;
  const params=new URLSearchParams(window.location.search);
  const clean=value=>(value||'').replace(/[^a-zA-Z0-9#\- _]/g,'').trim().slice(0,60);
  const order=clean(params.get('order')||params.get('order_number'));
  const packageKey=clean(params.get('package'));
  const packageNames={'one-page-website':'Launch','business-website':'Reviewed','shopify-store':'Studio','launch':'Launch','reviewed':'Reviewed','studio':'Studio'};
  const packageValue=packageNames[packageKey]||packageKey;
  if(order){
    const reference=section.querySelector('[data-order-reference]');
    const referenceValue=section.querySelector('[data-order-reference-value]');
    if(reference&&referenceValue){referenceValue.textContent=order.startsWith('#')?order:`#${order}`;reference.hidden=false}
  }
  const fieldLabel=field=>{
    const explicit=field.id?section.querySelector(`label[for="${CSS.escape(field.id)}"]`):null;
    const wrapping=field.closest('label');
    return [field.name,field.id,field.placeholder,field.getAttribute('aria-label'),explicit?.textContent,wrapping?.textContent].filter(Boolean).join(' ').toLowerCase();
  };
  const fillKnownFields=()=>{
    section.querySelectorAll('input,select,textarea').forEach(field=>{
      const clue=fieldLabel(field);
      let value='';
      if(order&&/(order|bestel).*(number|nummer|reference|referentie)|order_number/.test(clue))value=order.startsWith('#')?order:`#${order}`;
      if(packageValue&&/(package|pakket)/.test(clue))value=packageValue;
      if(!value||field.value||field.type==='hidden'||field.type==='file')return;
      if(field.tagName==='SELECT'){
        const option=[...field.options].find(item=>item.value.toLowerCase()===value.toLowerCase()||item.text.toLowerCase().includes(value.toLowerCase().replaceAll('-',' ')));
        if(!option)return;
        field.value=option.value;
      }else field.value=value;
      field.dispatchEvent(new Event('input',{bubbles:true}));
      field.dispatchEvent(new Event('change',{bubbles:true}));
    });
  };
  fillKnownFields();
  const host=section.querySelector('[data-brief-form-host]');
  if(host){
    const observer=new MutationObserver(fillKnownFields);
    observer.observe(host,{childList:true,subtree:true});
    window.setTimeout(()=>observer.disconnect(),12000);
  }
  const success=section.querySelector('[data-brief-success]');
  if(success)success.focus();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  (() => {
    const cartRoot = document.querySelector('[data-cart-root]');
    if (!cartRoot) return;

    const invalidLines = [...cartRoot.querySelectorAll('[data-cart-line]')].filter((line) => Number(line.dataset.lineQuantity) !== 1);
    if (invalidLines.length > 0) {
      const updates = {};
      invalidLines.forEach((line) => { updates[line.dataset.lineKey] = 1; });
      fetch(`${cartRoot.dataset.cartUrl}/update.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ updates })
      }).then((response) => {
        if (response.ok) window.location.reload();
      });
    }

    cartRoot.querySelectorAll('[data-remove-base-package]').forEach((removeLink) => {
      removeLink.addEventListener('click', async (event) => {
        event.preventDefault();
        removeLink.setAttribute('aria-disabled', 'true');

        try {
          const response = await fetch(`${cartRoot.dataset.cartClearUrl}.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' }
          });
          if (!response.ok) throw new Error('Cart clear failed');
          window.location.assign(cartRoot.dataset.cartUrl);
        } catch (error) {
          removeLink.removeAttribute('aria-disabled');
          window.location.assign(cartRoot.dataset.cartUrl);
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  (() => {
    const productOrder = document.querySelector('[data-product-order]');
    const addOnSelector = document.querySelector('[data-product-add-ons]');
    const packageForm = productOrder?.querySelector('[data-package-form]');
    if (!productOrder || !packageForm) return;

    const submitButton = packageForm.querySelector('[data-package-submit]');
    const errorMessage = packageForm.querySelector('[data-package-error]');
    const conflictMessage = packageForm.querySelector('[data-package-conflict]');
    const addOnOptions = addOnSelector ? [...addOnSelector.querySelectorAll('[data-addon-option]')] : [];
    const isAddOnProduct = productOrder.dataset.isAddOn === 'true';
    const baseVariantIds = new Set(productOrder.dataset.baseVariantIds.split(',').map((id) => Number(id)));

    const updateLabel = () => {
      const selectedCount = addOnOptions.filter((option) => option.checked).length;
      if (selectedCount === 0) submitButton.textContent = submitButton.dataset.defaultLabel;
      if (selectedCount === 1) submitButton.textContent = submitButton.dataset.singularLabel;
      if (selectedCount > 1) submitButton.textContent = submitButton.dataset.pluralLabel.replace('[count]', selectedCount);
    };

    addOnOptions.forEach((option) => option.addEventListener('change', updateLabel));
    updateLabel();

    packageForm.addEventListener('submit', async (event) => {
      event.preventDefault();
      errorMessage.hidden = true;
      conflictMessage.hidden = true;
      submitButton.disabled = true;
      submitButton.setAttribute('aria-busy', 'true');

      try {
        const cartResponse = await fetch(`${packageForm.dataset.cartUrl}.js`, {
          headers: { Accept: 'application/json' }
        });
        if (!cartResponse.ok) throw new Error('Cart lookup failed');

        const cartState = await cartResponse.json();
        const existingVariantIds = new Set(cartState.items.map((item) => Number(item.variant_id)));
        const packageVariantId = Number(packageForm.querySelector('input[name="id"]').value);
        const items = [];

        if (!isAddOnProduct) {
          const hasDifferentBasePackage = [...existingVariantIds].some((id) => baseVariantIds.has(id) && id !== packageVariantId);
          if (hasDifferentBasePackage) {
            conflictMessage.hidden = false;
            submitButton.disabled = false;
            submitButton.removeAttribute('aria-busy');
            return;
          }
        }

        if (!existingVariantIds.has(packageVariantId)) {
          items.push({ id: packageVariantId, quantity: 1 });
        }

        addOnOptions.filter((option) => option.checked).forEach((option) => {
          const addOnVariantId = Number(option.value);
          if (!existingVariantIds.has(addOnVariantId)) {
            items.push({ id: addOnVariantId, quantity: 1 });
            existingVariantIds.add(addOnVariantId);
          }
        });

        if (items.length > 0) {
          const response = await fetch(`${packageForm.dataset.cartAddUrl}.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items })
          });
          if (!response.ok) throw new Error('Cart request failed');
        }
        window.location.assign(packageForm.dataset.cartUrl);
      } catch (error) {
        errorMessage.hidden = false;
        submitButton.disabled = false;
        submitButton.removeAttribute('aria-busy');
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter-popup"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded',()=>{const popup=document.querySelector('[data-newsletter-popup]');if(!popup)return;const key='briefbuilt_newsletter_closed';const fourteenDays=14*24*60*60*1000;const loadedAt=Date.now();let previousFocus=null;let opened=false;const open=(force=false)=>{if(opened)return;if(!force&&document.querySelector('.shopify-pc__banner__dialog,[data-shopify-customer-privacy]'))return;opened=true;previousFocus=document.activeElement;popup.hidden=false;document.body.classList.add('newsletter-open');window.setTimeout(()=>popup.querySelector('input,button')?.focus(),50)};const close=()=>{opened=false;popup.hidden=true;document.body.classList.remove('newsletter-open');localStorage.setItem(key,String(Date.now()));previousFocus?.focus?.()};document.querySelectorAll('[data-newsletter-open]').forEach(button=>button.addEventListener('click',()=>open(true)));popup.querySelectorAll('[data-newsletter-close]').forEach(button=>button.addEventListener('click',close));document.addEventListener('keydown',event=>{if(!popup.hidden&&event.key==='Escape')close()});if(window.location.pathname==='/'){const closedAt=Number(localStorage.getItem(key)||0);if(!closedAt||Date.now()-closedAt>=fourteenDays){const timer=window.setTimeout(()=>open(),45000);if(window.matchMedia('(min-width: 900px)').matches){document.addEventListener('mouseout',event=>{if(Date.now()-loadedAt>=15000&&event.clientY<=0&&!event.relatedTarget){window.clearTimeout(timer);open()}},{once:true})}}}if(popup.querySelector('[data-newsletter-success]')){localStorage.setItem(key,String(Date.now()));open(true)}});

  } catch(e) { console.error(e); }
})();
})();
